const CONST = {
    'SET_CONFIG':'ROSTER/SET_CONFIG',
    'SET_SELECTED_ITEM':'ROSTER/SET_SELECTED_ITEM',
    'FETCH_ROSTER_STATS_SUCCESS':'ROSTER/FETCH_ROSTER_STATS_SUCCESS',
    'FETCH_ROSTER_STATS_FAILED':'ROSTER/FETCH_ROSTER_STATS_FAILED',
    'FETCH_ITEM_SUCCESS':'ROSTER/FETCH_ITEM_SUCCESS',
    'FETCH_ITEM_FAILED':'ROSTER/FETCH_ITEM_FAILED',
    'FETCH_ITEMS_SUCCESS':'ROSTER/FETCH_ITEMS_SUCCESS',
    'FETCH_ITEMS_FAILED':'ROSTER/FETCH_ITEMS_FAILED',
    'ADD_ITEM_SUCCESS':'ROSTER/ADD_ITEM_SUCCESS',
    'ADD_ITEM_FAILED':'ROSTER/ADD_ITEM_FAILED',
    'UPDATE_ITEM_SUCCESS':'ROSTER/UPDATE_ITEM_SUCCESS',
    'UPDATE_ITEM_FAILED':'ROSTER/UPDATE_ITEM_FAILED',
    'DELETE_ITEM_SUCCESS':'ROSTER/DELETE_ITEM_SUCCESS',
    'DELETE_ITEM_FAILED':'ROSTER/DELETE_ITEM_SUCCESS',

    'FETCH_ROSTER_LOG_SUCCESS':'ROSTER/FETCH_ROSTER_LOG_SUCCESS',
    'FETCH_ROSTER_LOG_FAILED':'ROSTER/FETCH_ROSTER_LOG_FAILED',
    'ADD_ROSTER_LOG_SUCCESS':'ROSTER/ADD_ROSTER_LOG_SUCCESS',
    'ADD_ROSTER_LOG_FAILED':'ROSTER/ADD_ROSTER_LOG_FAILED',
    'UPDATE_ROSTER_LOG_SUCCESS':'ROSTER/UPDATE_ROSTER_LOG_SUCCESS',
    'UPDATE_ROSTER_LOG_FAILED':'ROSTER/UPDATE_ROSTER_LOG_FAILED',
    'DELETE_ROSTER_LOG_SUCCESS':'ROSTER/DELETE_ROSTER_LOG_SUCCESS',
    'DELETE_ROSTER_LOG_FAILED':'ROSTER/DELETE_ROSTER_LOG_FAILED',

    'SET_CONFIG_SHIFT':'ROSTER/SET_CONFIG_SHIFT',
    'SET_SELECTED_SHIFT':'ROSTER/SET_SELECTED_SHIFT',
    'FETCH_SHIFT_SUCCESS':'ROSTER/FETCH_SHIFT_SUCCESS',
    'FETCH_SHIFT_FAILED':'ROSTER/FETCH_SHIFT_FAILED',
    'FETCH_SHIFTS_SUCCESS':'ROSTER/FETCH_SHIFTS_SUCCESS',
    'FETCH_SHIFTS_FAILED':'ROSTER/FETCH_SHIFTS_FAILED',
    'ADD_SHIFT_SUCCESS':'ROSTER/ADD_SHIFT_SUCCESS',
    'ADD_SHIFT_FAILED':'ROSTER/ADD_SHIFT_FAILED',
    'UPDATE_SHIFT_SUCCESS':'ROSTER/UPDATE_SHIFT_SUCCESS',
    'UPDATE_SHIFT_FAILED':'ROSTER/UPDATE_SHIFT_FAILED',
    'DELETE_SHIFT_SUCCESS':'ROSTER/DELETE_SHIFT_SUCCESS',
    'DELETE_SHIFT_FAILED':'ROSTER/DELETE_SHIFT_FAILED',

    'SET_CONFIG_CALENDAR':'ROSTER/SET_CONFIG_CALENDAR',
    'FETCH_ROSTER_CALENDAR_SUCCESS':'ROSTER/FETCH_ROSTER_CALENDAR_SUCCESS',
    'FETCH_ROSTER_CALENDAR_FAILED':'ROSTER/FETCH_ROSTER_CALENDAR_FAILED',

    'FETCH_WEEKLY_ROSTER_SUCCESS':'ROSTER/FETCH_WEEKLY_ROSTER_SUCCESS',
    'FETCH_WEEKLY_ROSTER_FAILED':'ROSTER/FETCH_WEEKLY_ROSTER_FAILED',
}

export default CONST;